"use client";

import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import {ArrowLeftIcon, ChevronRightIcon} from "lucide-react";

interface BreadcrumbsProps {
    steps: {
        name: string;
        href: string;
    }[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ steps }) => {
    const router = useRouter();

    return (
        <nav className="flex max-sm:flex-wrap max-sm:gap-y-4 items-center space-x-2 text-gray-600 py-4">
            {/* Back Button */}
            <button
                className="flex   items-center justify-center w-8 h-8 bg-gray-100 rounded-full mr-2"
                onClick={() => router.back()}
            >
                <ArrowLeftIcon className="h-5 w-5" aria-hidden="true" />
            </button>

            {/* Breadcrumbs */}
            {steps.map((step, index) => (
                <div key={index} className="flex items-center">
                    <Link hrefLang="it" title={step.name} href={step.href} className={`text-sm font-medium ${index === steps.length - 1 ? 'text-gray-500' : ''}`}>
                            {step.name}
                    </Link>
                    {index < steps.length - 1 && (
                        <ChevronRightIcon className="h-5 w-5 text-gray-400 mx-2" />
                    )}
                </div>
            ))}
        </nav>
    );
};

export default Breadcrumbs;
